import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useIntolerances = (patientId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["intolerances", patientId],
    queryFn: async () => {
      if (!patientId) return [];
      const axiosInstance = createAxiosInstance();
      const { data } = await axiosInstance.get(
        `${tenantVal}/allergy/getbyallergytype/INTOLERANCE/bypatient/${patientId}`
      );
      return data.filter((item) => item.allergyType === "INTOLERANCE");
    },
    enabled: !!patientId && !!tenantVal,
  });
};
